import { FC, useState } from 'react';
import { sounds } from '@whitesharx/starfall-frontend-ui-kit';
import { MENU_ITEMS, TOOLS_ITEMS } from './constants';
import {
  bottomContainerStyles,
  buildNumberStyles,
  containerStyles,
  contentContainerStyles,
  iconContainerStyles,
  iconMarginStyles,
  itemStyles,
  linkStyles,
  listStyles,
  logoContainerStyles,
  logoImageStyles,
  logoPictureStyles,
  sizeStyles,
  slotStyles,
  textStyles,
  toolItemIconStyles,
  toolItemPaddingStyles,
  toolItemStyles,
  toolsListStyles,
  wrapperStyles,
} from './styles.css';

const { version } = require('../../../../../package.json');

export type DesktopNavigationBarProps = {
  onItemClick?: () => void;
};

const playSound = () => sounds.play('click');

const DesktopNavigationBar: FC<DesktopNavigationBarProps & { banner: JSX.Element | null }> = ({
  onItemClick,
  banner,
}) => {
  const [feedbackLoading, setFeedbackLoading] = useState(false);

  const createFeedback = () => {
    setFeedbackLoading(true);
    playSound();

    window.createFeedback(() => setFeedbackLoading(false));
  };

  const onMenuItemClick = () => {
    playSound();
    onItemClick?.();
  };

  const onToolItemClick = (title: 'minimaze' | 'feedback' | 'settings') => () => {
    if (title === 'feedback') {
      playSound();
      createFeedback();
    }
    if (title === 'settings') {
      onMenuItemClick();
    }
  };

  return (
    <nav className={containerStyles}>
      <div>
        <div className={logoContainerStyles}>
          <picture className={logoPictureStyles}>
            <source srcSet="/assets/images/logo.webp" type="image/webp" />
            <img className={logoImageStyles} alt="Chess Royale logo" src="/assets/images/logo.png" />
          </picture>
        </div>

        <ul className={listStyles}>
          {MENU_ITEMS.map((item) => (
            <li className={itemStyles} key={item.title} onClick={onMenuItemClick}>
              <a className={`${linkStyles} ${sizeStyles}`}>
                <div className={contentContainerStyles}>
                  <div className={`${iconContainerStyles} ${iconMarginStyles}`}>{item.icon}</div>
                  <span className={textStyles}>{item.title}</span>
                </div>
              </a>
            </li>
          ))}
        </ul>
      </div>

      <div className={slotStyles}>{banner}</div>

      <div className={bottomContainerStyles}>
        <ul className={`${listStyles} ${toolsListStyles}`}>
          {TOOLS_ITEMS.map((item) => (
            <li
              className={`${toolItemStyles} ${toolItemPaddingStyles}`}
              key={item.title}
              onClick={onToolItemClick(item.title)}
              style={feedbackLoading ? { pointerEvents: 'none', cursor: 'not-allowed' } : undefined}
            >
              <div className={wrapperStyles}>
                <div className={toolItemIconStyles}>{item.icon}</div>
              </div>
              <div>
                <span>{item.title}</span>
              </div>
            </li>
          ))}
        </ul>

        <div className={buildNumberStyles}>Version: {version.replace('-master', '')}</div>
      </div>
    </nav>
  );
};

export default DesktopNavigationBar;
